import {snakeCase} from 'lodash';
import styled from 'styled-components';

import DiscountPriceLabel from '~/shared/components/DiscountPriceLabel';
import {calculateBillingLinesForDisplay} from '~/shared/services/payments';
import {PriceLabel} from '~/shared/components/PriceLabels';
import {getLocalizationService} from '~/shared/services/localisationService';
import {BillingLineType} from '~/shared/consts/checkoutConsts';
import {FlexCenter, FlexSpace} from '~/shared/theme/FlexLayout';
import TotalSavedTag from '~/shared/components/TotalSavedTag';
import {isHiddenBillingLine} from '~/shared/utils/billingLinesCalculation';

import Section from './parts/Section';
import Quantity from './parts/Quantity';

const BillingDetailsWrapper = styled(Section)`
  margin-top: 0;
  padding-top: 0;
  font-weight: bold;
`;

const BoldedTotalCharge = styled(Quantity)`
  font-weight: ${({type}) => (type === BillingLineType.TotalToCharge ? 'bold' : 'normal')};
  width: auto;
`;

const ColoredBillingDetailLines = styled(FlexSpace)`
  width: 100%;
  color: ${({theme, type}) =>
    (type === BillingLineType.DiscountCoupon ? theme.colors.primary : theme.orderSuccess.body.headerTextColor)};
`;

const ModifiedTotalSavedTag = styled(TotalSavedTag)`
  margin-top: 8px;
`;

const BillingLinesDetails = ({isBarCodeOrder, billingLines, className = '', totalSaved = 0, isBenefitsHighlightEnabled, orderCoupon = null}) => {
  const {t} = getLocalizationService();

  const billingLinesForDisplay = billingLines && calculateBillingLinesForDisplay(billingLines);

  return isBarCodeOrder ? null : (
    <BillingDetailsWrapper className={className}>
      {billingLinesForDisplay &&
        billingLinesForDisplay.map(({amount, type, discountsData, ...rest}) => (!isHiddenBillingLine({
          couponValueType: orderCoupon?.discountType,
          billingLinePriority: rest.priority,
          billingType: type,
        }) ? (
          <ColoredBillingDetailLines key={type} type={type} data-test-id={`order_summary_${type}`}>
            <BoldedTotalCharge type={type}>{`${t(`order_success_${snakeCase(type)}`)}`}</BoldedTotalCharge>
            {discountsData ? (
              <FlexCenter>
                <DiscountPriceLabel
                  billingLine={{amount, discountsData, type, ...rest}}
                  sign={amount < 0 ? '-' : undefined}
                  isUserBenefitsHighlightEnabled={isBenefitsHighlightEnabled}
                  priceDataTestId="BillingLine"
                  priceBeforeDiscountTestId={`BillingLine_${type}BeforeDiscount`}
                />
              </FlexCenter>
            ) : (
              <PriceLabel
                priceDataTestId={`BillingLine_${type}`}
                price={Math.abs(amount)}
                sign={amount < 0 ? '-' : undefined}
                type={type}
              />
            )}
          </ColoredBillingDetailLines>
        ) : null))}
      {Boolean(totalSaved) && <ModifiedTotalSavedTag amount={totalSaved} />}
    </BillingDetailsWrapper>
  );
};

export default BillingLinesDetails;
